module.exports = __webpack_public_path__ + "static/mopz-double2-min-c0280f6773ee2bca0f0f233caed3fbbe.jpg";